<template>
    <!--会员微信绑定记录-->
    <pop-form v-if="show" width="990px" body-max-height="547px">
        <template v-slot:title>
            {{title}}
            <span class="close" @click="close">
                <i class="el-icon-close"></i>
            </span>
        </template>
        <div class="history-box">
            <div class="search-box">
                <el-date-picker
                        v-model="startDate"
                        type="date"
                        placeholder="选择开始日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions">
                </el-date-picker>&nbsp;&nbsp;
                <el-date-picker
                        v-model="endDate"
                        type="date"
                        placeholder="选择结束日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions">
                </el-date-picker>&nbsp;&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="loadListData">搜索</el-button>
            </div>

            <div class="list-box">
                <el-table :data="listData" style="width: 100%" height="430"  cell-class-name="list-table-ceil"
                          header-cell-class-name="list-table-ceil">
                    <el-table-column prop="create_datetime" label="绑定时间" />
                    <el-table-column prop="name" label="姓名" />
                    <el-table-column prop="wechat_name" label="绑定时微信昵称" />
                </el-table>
            </div>
        </div>
        <template v-slot:foot>
            <div class="page-box">&nbsp;</div>
        </template>
    </pop-form>
</template>

<script>
    import obj from "@/js/obj";
    import PopForm from "@/model/PopForm";
    export default {
        name: "StoreUserBindHistory",
        components: {PopForm},
        model: {
            prop: "show",
            event: "showChange"
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            storeUid: {
                type: [String, Number],
                default: ""
            }
        },
        data: () => ( {
            title: "绑定记录",
            startDate: "",
            endDate: "",
            listData: [],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
        } ),
        methods: {
            //搜索
            loadListData: function () {
                let postData = {
                    store_uid: this.storeUid,
                    start_date: this.startDate,
                    end_date: this.endDate,
                };
                obj.postData("store_user/get_wechat_bind_history", postData, res => {
                    if(res.errcode === 0) {
                        this.listData = res.data;
                    }else{
                        obj.message.error(res.errdesc);
                    }
                });
            },
            //关闭
            close: function () {
                this.$emit("showChange", false);
            }
        },
        watch: {
            show: function (val) {
                if(val) this.loadListData();
            }
        }
    }
</script>

<style scoped>
    .close{
        float: right;
    }
    .search-box{
        margin: 6px 6px 0px;
    }
    .list-box{
        margin-top: 16px;
    }
</style>
